import axios from 'axios';
import getHeaderToken from 'functions/getHeaderToken';
import { Logger } from 'aws-amplify';

const logger = new Logger('upsertOptionPermissionStatus-log');

const upsertOptionPermissionStatus = async (perms, endpoint, app_id, function_id, nextStatus, setState) => {
    const alertMsg = 'エラーにより実行できません';
    const arr = perms?.data;

    if (!Array.isArray(arr) || arr.length === 0) {
        alert(alertMsg);
        return;
    }

    const office_no = arr[0]?.office_number;
    if (!office_no || office_no.length === 0) {
        alert(alertMsg);
        return;
    }

    if (typeof app_id !== 'string' || typeof function_id !== 'string') {
        alert(alertMsg);
        return;
    }

    if (nextStatus !== 0 && nextStatus !== 1) {
        alert(alertMsg);
        return;
    }

    const current = arr.find((obj) => obj.app_id === app_id && obj.function_id === function_id);
    const requestType = current ? 'put' : 'post';

    const ep = endpoint || '';

    if (ep.length === 0) {
        alert(alertMsg);
        return;
    }

    const body = requestType === 'put'
        ? {
            office_no,
            app_id,
            function_id,
            statusToChange: nextStatus,
        }
        : {
            office_no,
            app_id,
            function_id,
            initial_status: nextStatus,
        };

    try {
        const header = await getHeaderToken();
        const res = requestType === 'put'
            ? await axios.put(ep, body, header)
            : await axios.post(ep, body, header);

        if (res.status === 204) {
            setState(nextStatus);
            return;
        }

        logger.error(`Unexpected status: ${res.status}`);
        alert(alertMsg);
    } catch (e) {
        logger.error(e);
        alert(alertMsg);
    }
};

export default upsertOptionPermissionStatus;
